// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-link[data-v-273720f4]{display:inline-block;color:#002560;font-size:20px;margin-bottom:5px;border-bottom:2px solid #002560;font-size:16px;font-weight:500}.menu-caption[data-v-273720f4]{color:#777e85;font-size:12px;max-width:300px}\n", ""]);
// Exports
module.exports = exports;
